<template>
    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Nom</label>
                    <md-input v-model="documentType.name" name="name" required type="text"></md-input>
                    <validation-error :errors="apiValidationErrors.name" />
                </md-field>
            </div>
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Poids</label>
                    <md-input v-model="documentType.order" required type="number"></md-input>
                    <validation-error :errors="apiValidationErrors.order" />
                </md-field>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-size-100 mt-4">
                <md-checkbox v-model="documentType.isActive">Etat</md-checkbox>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "FormContent",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        documentType: {
            type: Object,
            default() {
                return {
                    name: '',
                    isActive: true,
                    order: 0,
                    parentId: null
                }
            }
        },
        errors: Array,
    },
    watch: {
        errors: function(newVal, oldVal) {
            this.resetApiValidation();
            if(newVal) {
                this.setApiValidation(newVal);
            }
        }
    }
}
</script>

<style scoped>

</style>